import { Icon } from 'assets/index'
import { IMAGES } from 'configs/configs.js'
import { Dispatch, SetStateAction } from 'react'
import { Container } from './style'

interface IProps {
  especialistaFiltro: any[]
  setEspecialistaFiltro: Dispatch<SetStateAction<any[]>>
}

export default function SelectedSpecialists(props: IProps) {
  const { especialistaFiltro, setEspecialistaFiltro } = props
  return (
    <Container>
      {especialistaFiltro.map((item: any) => {
        return (
          <div key={item.id} className="selected-especialist">
            <img
              src={`${IMAGES.URL}/images/${item.profilePic}`}
              alt="profile pic"
              className="profile-pic"
              onError={(e) => {
                e.currentTarget.src = `${IMAGES.URL}/images/profile_placeholder.png`
                // caso a imagem não exista, exibe a imagem de perfil padrão
              }}
            />
            <span className="username"> {item.label}</span>

            <button
              type="button"
              className="remove-btn"
              onClick={() => {
                // Remover o especialista da lista
                setEspecialistaFiltro((prev: any[]) =>
                  prev.filter((especialist) => especialist.value !== item.value)
                )
              }}
            >
              <img src={Icon(`x_circle.svg`)} alt="profile pic" />
            </button>
          </div>
        )
      })}
    </Container>
  )
}
